import { TargetImageData } from "../../types/TargetImageData";
import targetImagesConfigs from "../../configs/targetImagesConfigs.json";

export const getTargetImageData = (targetId: string): TargetImageData => {
    const data = targetImagesConfigs[targetId];

    if (!data) {
        throw new Error(`Target image config not found for ID: ${targetId}`);
    }
    return data as TargetImageData;
};